import { PropsWithChildren } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: ['Helvetica Neue', 'Helvetica', 'sans-serif'].join(','),
  },
  palette: {
    primary: {
      main: 'hsla(281, 53%, 33%, 1)',
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& input, & .MuiSelect-select': {
            fontWeight: 500,
            fontSize: `${14 / 16}rem`,
            ':focus': {
              backgroundColor: 'transparent',
            },
          },
        },
      },
    },
    MuiMenuItem: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          padding: '16px',
          fontSize: `${14 / 16}rem`,
          fontWeight: 500,
          ':hover, &.Mui-selected': {
            backgroundColor: 'var(--brand-primary-06) !important',
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        root: {
          marginTop: '18px',
        },
        paper: {
          padding: 0,
          boxShadow: 'none !important',
          border: 'var(--border-base-grey-10)',
          transition: 'none !important',
        },
        list: {
          padding: 0,
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiTabs: {
      styleOverrides: {
        flexContainer: {
          borderBottom: '1px solid hsla(234, 8%, 23%, 0.1)',
        },
        indicator: {
          backgroundColor: 'hsla(234, 8%, 23%, 1)',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minWidth: '180px',
          textTransform: 'none',
          fontFamily: 'FuturaStd',
          color: 'hsla(234, 8%, 23%, 0.6)',
          '&.Mui-selected': {
            color: 'hsla(234, 8%, 23%, 1)',
          },
        },
      },
    },
  },
});

interface MuiThemeProviderProps {}

function MuiThemeProvider({
  children,
}: PropsWithChildren<MuiThemeProviderProps>) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export { MuiThemeProvider };
